<div>
  <web-components-app-info />
  @if (customInfoType) {
    <web-components-custom-info
      [headline]="'login.default.custom-info-cards.' + customInfoType + '.headline' | transloco"
      [text]="'login.default.custom-info-cards.' + customInfoType + '.text' | transloco"
    />
  }
</div>
